import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import "./IncentivizedReviewWarning.scss";

type IncentivizedReviewWarningProps = {
  visible: boolean;
};

const IncentivizedReviewWarning: React.FC<IncentivizedReviewWarningProps> = ({
  visible,
}) => {
  if (!visible) return null;

  return (
    <div className="incentivized-review-warning">
      <div className="incentivized-review-warning__alert">
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          className="incentivized-review-warning__icon incentivized-review-warning__icon--alert"
        />
        <p className="incentivized-review-warning__text">
          <strong>
            Asking creators to leave Google, Yelp, or 5-star reviews is not
            allowed.
          </strong>{" "}
          These are considered incentivized reviews and may violate policies on
          platforms like Google Maps, Yelp, and TripAdvisor.
        </p>
      </div>
      <div className="incentivized-review-warning__success">
        <FontAwesomeIcon
          icon={faCheck}
          className="incentivized-review-warning__icon incentivized-review-warning__icon--success"
        />
        <p className="incentivized-review-warning__text">
          You can ask creators to share their experience on Instagram or TikTok
          instead.
        </p>
      </div>
    </div>
  );
};

export default IncentivizedReviewWarning;
